import React, { FC } from "react"

import { GroupDocument } from "../../../../contexts/devices-context"
import OperatingTimeModuleSettings, { WittyPiScheduleAttribute } from "./OperatingTimeModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type GroupOperatingTimeModuleSettingsProps = {
    group: GroupDocument
}

const _GroupOperatingTimeModuleSettings: FC<GroupOperatingTimeModuleSettingsProps> = ({ group }) => {
    const attrs = useModuleAttributes<"schedule", WittyPiScheduleAttribute>(group, "wittypi")

    return <OperatingTimeModuleSettings attrs={attrs} organisation={group.organisation} group={group.id} />
}

export default _GroupOperatingTimeModuleSettings
